export const DEFAULT_LOCALE = 'en-US';
export const DEFAULT_LOCALE_UNDERSCORE = 'en_US';
// TODO(agent-port): port the real locale resolution from eb-ui (getParentLocale).
export function getFinalLocale(locale?: string): string {
  return locale || DEFAULT_LOCALE;
}
